import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, UserCheck, Wallet, Camera, Copy, ClipboardCheck, MessageSquare, Share2 } from "lucide-react";
import { Link } from "react-router-dom";
import { client } from "@/lib/api";
import { money } from "@/lib/format";

function Stat({ icon: Icon, label, value, testId }) {
  return (
    <div className="card-warm !p-5">
      <Icon className="w-7 h-7 text-[#8C3415]" />
      <p className="label-cap mt-3">{label}</p>
      <p data-testid={testId} className="font-heading text-3xl font-bold mt-1">{value}</p>
    </div>
  );
}

export default function OverviewTab({ go }) {
  const [s, setS] = useState(null);
  useEffect(() => { client("admin").get("/admin/stats").then((r) => setS(r.data)); }, []);
  const link = window.location.origin;
  const msg = `Talofa lava ʻāiga! Register for the Fanene Family Reunion here: ${link}`;
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Copied"); };
  if (!s) return <p>Loading…</p>;
  return (
    <div className="space-y-8">
      <h2 className="text-3xl font-bold text-amber-950">Overview</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label="Families" value={s.families} testId="stat-families" />
        <Stat icon={Users} label="People" value={s.members} testId="stat-members" />
        <Stat icon={UserCheck} label="Checked in" value={`${s.checked_in}/${s.families}`} testId="stat-checked-in" />
        <Stat icon={Camera} label="Photos" value={s.photos} testId="stat-photos" />
      </div>
      <div className="card-warm grid sm:grid-cols-3 gap-4 items-center">
        <div><Wallet className="w-7 h-7 text-[#2B5338]" /><p className="label-cap mt-2">Collected</p><p data-testid="stat-total-paid" className="font-heading text-3xl font-bold">{money(s.total_paid)}</p></div>
        <div><p className="label-cap">Expected</p><p data-testid="stat-total-due" className="font-heading text-3xl font-bold">{money(s.total_due)}</p></div>
        <div><p className="label-cap">Families fully paid</p><p data-testid="stat-paid-families" className="font-heading text-3xl font-bold">{s.paid_families}/{s.families}</p></div>
        {s.unlinked_count > 0 && (
          <button data-testid="stat-unlinked-payments" onClick={() => go("payments")} className="sm:col-span-3 text-left rounded-xl bg-amber-50 border-2 border-amber-300 p-4 text-lg hover:bg-amber-100">
            <b>{s.unlinked_count}</b> payment{s.unlinked_count === 1 ? "" : "s"} ({money(s.unlinked_total)}) not linked to a family yet — tap to link
          </button>
        )}
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-warm space-y-3">
          <h3 className="text-2xl font-bold text-amber-900">Share with families</h3>
          <p className="text-stone-700">On your phone, tap "Text it" to open Messages with this ready to send to your ʻāiga:</p>
          <p data-testid="share-message" className="rounded-xl bg-[#FDF6ED] p-4 text-lg break-words">{msg}</p>
          <div className="flex flex-wrap gap-3">
            <a data-testid="text-share-message" href={`sms:?&body=${encodeURIComponent(msg)}`} className="btn-primary"><MessageSquare className="w-5 h-5" />Text it</a>
            {navigator.share && <button data-testid="native-share-button" onClick={() => navigator.share({ text: msg }).catch(() => {})} className="btn-outline"><Share2 className="w-5 h-5" />Share…</button>}
            <button data-testid="copy-share-message" onClick={() => copy(msg)} className="btn-secondary"><Copy className="w-5 h-5" />Copy message</button>
            <button data-testid="copy-share-link" onClick={() => copy(link)} className="btn-outline">Copy link only</button>
          </div>
        </div>
        <div className="card-warm space-y-3">
          <h3 className="text-2xl font-bold text-amber-900">At the reunion</h3>
          <p className="text-stone-700">Open the check-in desk on any phone or tablet. Volunteers just need the PIN.</p>
          <Link to="/checkin" target="_blank" data-testid="open-checkin-link" className="btn-primary"><ClipboardCheck className="w-5 h-5" />Open check-in desk</Link>
          <button data-testid="goto-backup-button" onClick={() => go("backup")} className="btn-outline">Import / download backup</button>
        </div>
      </div>
    </div>
  );
}
